var getMeshMixin = require("../getMeshMixin");
var registerPrimitive = require("../primitives").registerPrimitive;
var utils = require("../../../utils/");

registerPrimitive(
  "a-image",
  utils.extendDeep({}, getMeshMixin(), {
    defaultComponents: {
      geometry: {
        primitive: "plane",
      },
      material: {
        color: "#FFF",
        shader: "flat",
        side: "double",
        transparent: true,
      },
    },

    mappings: {
      height: "geometry.height",
      width: "geometry.width",
    },
  })
);
